export const BANK_ACCOUNTS = [
  { bank: "Eurobank", iban: "GR81 0260 2820 0001 8020 1117 908" },
  { bank: "Τράπεζα Πειραιώς", iban: "GR85 0171 6240 0066 2411 0345 360" },
  { bank: "Alpha Bank", iban: "GR50 0140 7150 7150 0210 1108 178" },
  { bank: "Εθνική Τράπεζα", iban: "GR28 0110 2360 0000 2360 0677 258" },
  { bank: "Viva Wallet", iban: "GR78 7010 0000 0006 9550 6552 313" },
] as const;

export const BENEFICIARY = "ΑΣΛΑΝΟΓΛΟΥ Β. ΑΙΚΑΤΕΡΙΝΗ (ΑΦΜ: 117875310)";